import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {LoginComponent} from './login/login.component';
import {PartnersComponent} from './partners/partners.component';
import {StoreComponent} from './store/store.component';
import {StoreResolver} from './store/store.resolver';
import {AffiliateProgramComponent} from './affiliate-program/affiliate-program.component';
import {ContactsComponent} from './contacts/contacts.component';
import {AboutUsComponent} from './about-us/about-us.component';
import {SignInComponent} from './sign-in/sign-in.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {AdminTestComponent} from './admin-test/admin-test.component';
import {FullComponent} from './admin-ui/layouts/full/full.component';
import {UserResolver} from './admin-ui/user.resolver';
import {VpsResolver} from './admin-ui/vps.resolver';
import {SoftwaresResolver} from './admin-ui/softwares.resolver';
import {UserAccessGuardService} from './admin-ui/user-access-guard.service';
import {LoginResolver} from './login/login.resolver';
import {GetStartedComponent} from './get-started/get-started.component';
import {ActivationHandlerComponent} from './activation-handler/activation-handler.component';
import {PartnerManagerComponent} from './partner-manager/partner-manager.component';
import {RequestActivationResolver} from './partner-manager/request-activation.resolver';
import {PartnerResolver} from './partner-manager/partner.resolver';
import {PartnerUsersResolver} from './partner-manager/partner-users.resolver';
import {PartnerAccessGuardService} from './partner-manager/partner-access-guard.service';
import {AdminManagerComponent} from './admin-manager/admin-manager.component';
import {AdminResolver} from './admin-manager/admin.resolver';
import {AdminSoftwaresResolver} from './admin-manager/admin-softwares.resolver';
import {VpsAdminResolver} from './admin-manager/vps-admin.resolver';
import {AdminAccessGuardService} from './admin-manager/admin-access-guard.service';
import {LoginAdminComponent} from './login-admin/login-admin.component';

/**
 * IMPORTANTE: non usare resolver per animazioni wrapkit
 *
 */

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'prefix'
  },
  {
    path: 'home',
    component: HomeComponent,
    pathMatch: 'full'
  },
  {
    path: 'partners',
    component: PartnersComponent,
    pathMatch: 'full'
  },
  {
    path: 'store/:software',
    component: StoreComponent,
    resolve: {software:StoreResolver},
    pathMatch: 'full'
  },
  {
    path: 'store',
    component: StoreComponent,
    resolve: {software:StoreResolver},
    pathMatch: 'full'
  },
  {
    path: 'affiliate program',
    component: AffiliateProgramComponent,
    pathMatch: 'full'
  },
  {
    path: 'contattaci',
    component: ContactsComponent,
    pathMatch: 'full'
  },
  {
    path: 'chi siamo',
    component: AboutUsComponent,
    pathMatch: 'full'
  },
  {
    path: 'reset-password/:passkey',
    component: ResetPasswordComponent,
    pathMatch: 'prefix'
  },
  {
    path: 'login',
    component: LoginComponent,
    resolve: {cookies:LoginResolver},
    pathMatch: 'prefix'
  },
  {
    path: 'login/:name1',
    component: LoginComponent,
    resolve: {cookies:LoginResolver},
    pathMatch: 'prefix'
  },
  {
    path: 'login/:name1/:name2',
    component: LoginComponent,
    resolve: {cookies:LoginResolver},
    pathMatch: 'prefix'
  },
  {
    path: 'login/:name1/:name2/:email/:password',
    component: LoginComponent,
    resolve: {cookies:LoginResolver},
    pathMatch: 'prefix'
  },
  {
    path: 'sign-in/:affiliate',
    component: SignInComponent,
    pathMatch: 'prefix'
  },
  {
    path: 'sign-in',
    component: SignInComponent,
    pathMatch: 'prefix'
  },
  {
    path: 'come funziona',
    component: GetStartedComponent,
    pathMatch: 'prefix'
  },
  {
    path: 'adminLogin',
    component: LoginAdminComponent,
    pathMatch: 'prefix'
  },
  {
    path: 'admin_manager',
    component: AdminManagerComponent,
    pathMatch: 'prefix',
    resolve: {requests:AdminResolver, admin_softwares: AdminSoftwaresResolver, vps: VpsAdminResolver
    },
    canActivate: [AdminAccessGuardService]
  },
  {
    path: 'partner_manager',
    component: PartnerManagerComponent,
    pathMatch: 'prefix',
    resolve: {softwares: PartnerResolver, requests: RequestActivationResolver,
      affiliates: PartnerUsersResolver},
    canActivate: [PartnerAccessGuardService]
  },
  {
    path: 'confirm/:email/:passkey/:partner'/*/:passkey/:partner'*/,
    component: ActivationHandlerComponent,
    pathMatch: 'prefix'
  },
  {
    path: 'admin',
    component: FullComponent,
    resolve: {user:UserResolver, softwares: SoftwaresResolver, vps: VpsResolver},
    loadChildren: () => import('./admin-ui/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [UserAccessGuardService],
    /*children: [
      {
        path: 'admin',
        redirectTo: 'admin/dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./admin-ui/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'component',
        loadChildren: () => import('./admin-ui/component/component.module').then(m => m.ComponentsModule)
      }
    ],*/
    pathMatch:'prefix'
  },

  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
